module.exports = __webpack_public_path__ + "img/1.e42bf6fb.gif";